<template>
    <div class="mycard">
        <v-card-text class="card-text">
            Регистрация
            <v-form @submit.prevent="validate" novalidate>
                <v-select
                    class="mt-5"
                    :items="enterGrades"
                    v-model="enterGrade"
                    item-text="fullName"
                    label="Выберите класс поступления"
                    :error-messages="enterGradeErrors"
                    required
                    @input="$v.enterGrade.$touch()"
                    @blur="$v.enterGrade.$touch()"
                    prepend-icon="mdi-view-sequential"
                >
                </v-select>

                <v-select
                    class="mt-1"
                    :items="profiles"
                    v-model="profile"
                    item-text="Предмет"
                    label="Выберите профиль поступления"
                    :error-messages="profileErrors"
                    required
                    @input="$v.profile.$touch()"
                    @blur="$v.profile.$touch()"
                    prepend-icon="mdi-view-sequential"
                >
                </v-select>

                <v-row>
                    <v-col cols="12" md="6" class="nopadding"
                        ><v-text-field
                            v-model.trim="surname"
                            label="Фамилия участника"
                            :error-messages="surnameErrors"
                            required
                            @input="$v.surname.$touch()"
                            @blur="$v.surname.$touch()"
                            prepend-icon="mdi-account"
                        ></v-text-field>
                        <v-text-field
                            v-model.trim="name"
                            label="Имя участника"
                            :error-messages="nameErrors"
                            required
                            @input="$v.name.$touch()"
                            @blur="$v.name.$touch()"
                            prepend-icon="mdi-account"
                        ></v-text-field>
                        <v-text-field
                            v-model.trim="patronymic"
                            label="Отчество участника"
                            :error-messages="patronymicErrors"
                            required
                            @input="$v.patronymic.$touch()"
                            @blur="$v.patronymic.$touch()"
                            prepend-icon="mdi-account"
                        ></v-text-field>
                        <v-text-field
                            v-mask="'##.##.####'"
                            v-model="birth"
                            label="Дата рождения участника"
                            :error-messages="birthErrors"
                            required
                            @input="$v.birth.$touch()"
                            @blur="$v.birth.$touch()"
                            prepend-icon="mdi-calendar-range"
                        ></v-text-field>
                        <v-text-field
                            v-mask="'###-###-### ##'"
                            v-model="snils"
                            label="Номер СНИЛС участника"
                            :error-messages="snilsErrors"
                            required
                            @input="$v.snils.$touch()"
                            @blur="$v.snils.$touch()"
                            prepend-icon="mdi-badge-account-horizontal"
                        ></v-text-field>
                        <v-select
                            :items="confirmGrades"
                            v-model="confirmGrade"
                            item-text="fullName"
                            label="Класс обучения участника сейчас"
                            :error-messages="confirmGradeErrors"
                            required
                            @input="$v.confirmGrade.$touch()"
                            @blur="$v.confirmGrade.$touch()"
                            prepend-icon="mdi-view-sequential"
                        >
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="6" class="nopadding">
                        <v-text-field
                            v-model="parent"
                            label="ФИО родителя"
                            :error-messages="parentErrors"
                            required
                            @input="$v.parent.$touch()"
                            @blur="$v.parent.$touch()"
                            prepend-icon="mdi-badge-account-horizontal"
                        ></v-text-field>
                        <v-text-field
                            v-mask="'#-###-###-##-##'"
                            v-model="phone"
                            label="Контактный телефон родителя"
                            :error-messages="phoneErrors"
                            required
                            @input="$v.phone.$touch()"
                            @blur="$v.phone.$touch()"
                            prepend-icon="mdi-phone"
                        ></v-text-field>
                        <v-text-field
                            type="email"
                            v-model="email"
                            label="Адрес эл. почты (1 регистрация = 1 почта). Укажите личную, а не рабочую почту."
                            :error-messages="emailErrors"
                            required
                            @input="$v.email.$touch()"
                            @blur="$v.email.$touch()"
                            prepend-icon="mdi-mail"
                        ></v-text-field>
                        <v-text-field
                            v-model="parentSecond"
                            label="ФИО родителя 2"
                            prepend-icon="mdi-badge-account-horizontal"
                        ></v-text-field>
                        <v-text-field
                            v-mask="'#-###-###-##-##'"
                            v-model="phoneSecond"
                            label="Контактный телефон родителя 2"
                            prepend-icon="mdi-phone"
                        ></v-text-field>
                        <v-text-field
                            v-model="currentSchool"
                            label="Школа обучения участника сейчас (краткое название)"
                            :error-messages="currentSchoolErrors"
                            required
                            @input="$v.currentSchool.$touch()"
                            @blur="$v.currentSchool.$touch()"
                            prepend-icon="mdi-school"
                        ></v-text-field>
                    </v-col>
                    <v-text-field
                        class="px-3"
                        v-model="prevId"
                        label="Предыдущий личный номер абитуриента (например, 7-РМС-600) (Если вы не указали номер участника из основного или второго потока, то результаты учтены не будут)"
                        prepend-icon="mdi-badge-account-horizontal"
                    ></v-text-field>
                </v-row>

                <v-checkbox
                    id="terms1"
                    @change="$v.terms1.$touch()"
                    v-model="terms1"
                    @blur="$v.terms.$touch()"
                >
                    <template v-slot:label>
                        Я даю свое согласие на обработку своих персональных
                        данных и данных ребенка, родителем (законным
                        представителем) которого я являюсь.
                    </template>
                </v-checkbox>

                <v-checkbox
                    id="terms2"
                    @change="$v.terms2.$touch()"
                    v-model="terms2"
                >
                    <template v-slot:label>
                        <div>
                            Я ознакомлен(а) с
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <a
                                        target="_blank"
                                        href="https://st.educom.ru/eduoffices/gateways/get_file.php?id={8F3E10BD-D953-37EA-C64D-02EA85974934}&name=%D0%9Fravila-priema-v-%D0%93%D0%91%D0%9E%D0%A3-%D0%A8kola-%E2%84%96_1535-na-2025-26-uchebnyy-god.pdf"
                                        @click.stop
                                        v-on="on"
                                    >
                                        Правилами приема и приложениям к ним.
                                    </a>
                                </template>
                                Откроется в новом окне
                            </v-tooltip>
                        </div>
                    </template>
                </v-checkbox>

                <!-- <v-checkbox
                    id="terms3"
                    @change="$v.terms3.$touch()"
                    v-model="terms3"
                >
                    <template v-slot:label>
                        <div>
                            Я ознакомлен(а) с
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <a
                                        target="_blank"
                                        href="https://drive.google.com/file/d/1byDIY1xjJd-aplSxvjVy5Ys0gxeJToAy/view"
                                        @click.stop
                                        v-on="on"
                                    >
                                        Регламентом проведения вступительных
                                        испытаний в дистанционном формате
                                    </a>
                                </template>
                                Откроется в новом окне
                            </v-tooltip>
                            и
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <a
                                        target="_blank"
                                        href="https://drive.google.com/file/d/1b-gU9_GuWLJGlw13rh9QeA2Nfun3Sm3A/view"
                                        @click.stop
                                        v-on="on"
                                    >
                                        техническими требованиями.
                                    </a>
                                </template>
                                Откроется в новом окне
                            </v-tooltip>
                        </div>
                    </template>
                </v-checkbox> -->
                <v-checkbox
                    id="terms4"
                    @change="$v.terms4.$touch()"
                    v-model="terms4"
                >
                    <template v-slot:label>
                        <div>
                            Я проверил(а) корректность введенных данных,
                            особенно выбранный класс (параллель и профиль), куда
                            поступает абитуриент.
                        </div>
                    </template>
                </v-checkbox>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="sitekey"
                @verify="submitEnrollee"
                @expired="onCaptchaExpired"
            />
            <v-btn
                type="submit"
                color="primary"
                @click="validate"
                :disabled="$v.$invalid"
                style="width: 120px"
                :loading="loader"
                >Отправить</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { required, minLength, sameAs, email } from 'vuelidate/lib/validators'
import { bus } from '../../main'
export default {
    data() {
        return {
            sitekey: '6Le-imQaAAAAAC_Bgq1s2haE9A1IGTEL6YgLo2N2',
            enterGrades: [7, 8, 9, 10],
            enterGrade: null,
            profiles: [],
            profile: null,
            surname: '',
            name: '',
            patronymic: '',
            birth: '',
            snils: '',
            parent: '',
            phone: '',
            parentSecond: '',
            phoneSecond: '',
            email: '',
            currentSchool: '',
            prevId: '',
            confirmGrades: [6, 7, 8, 9],
            confirmGrade: '',
            terms1: false,
            terms2: false,
            // terms3: false,
            terms4: false,
            loader: false,
        }
    },
    components: { VueRecaptcha },
    name: 'Login',
    props: {
        source: String,
    },
    methods: {
        capitalize(string) {
            return (
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
            )
        },
        async submitEnrollee(recaptchaToken) {
            const enrollee = {
                profile: this.profile,
                surname: this.capitalize(this.surname),
                name: this.capitalize(this.name),
                patronymic: this.capitalize(this.patronymic),
                birth: this.birth,
                snils: this.snils,
                parent: this.parent,
                phone: this.phone,
                parentSecond: this.parentSecond,
                phoneSecond: this.phoneSecond,
                email: this.email.toLowerCase(),
                currentSchool: this.currentSchool,
                prevId: this.prevId,
                recaptchaToken: recaptchaToken,
                confirmGrade: this.confirmGrade,
            }
            this.loader = true
            const data = await this.$axios({
                url: '/api/submit-enrollee/',
                data: enrollee,
                method: 'POST',
            })
            if (data.data.answer == 'fail') {
                bus.$emit('snackbar', data.data.text)
                this.onCaptchaExpired()
            } else {
                bus.$emit('snackbar', data.data.text)
                this.$emit('formSubmitted')
                this.onCaptchaExpired()
                this.clearForm()
            }
            this.loader = false
            this.onCaptchaExpired()
        },
        async getProfiles() {
            this.profiles = []
            this.profile = null
            const result = await this.$axios({
                url: '/api/getprofilesbygrade/',
                data: { grade: this.enterGrade },
                method: 'POST',
            })
            if (result.data == 'no') {
                this.profiles = ['Нет доступных профилей']
            } else {
                this.profiles = result.data
            }
        },
        validate(event) {
            event.preventDefault()
            if (+this.enterGrade - +this.confirmGrade !== 1) {
                bus.$emit(
                    'snackbar',
                    'Ошибка в заполнении формы: проверьте, что вы верно указали класс обучения сейчас и класс поступления (если абитуриент учится в 7 классе, то класс поступления - 8, если в учится в 6 классе, то поступает в 7 и т.д.).'
                )
            } else {
                this.$refs.recaptcha.execute()
            }
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset()
        },
        clearForm() {
            ;(this.profile = ''),
                (this.surname = ''),
                (this.name = ''),
                (this.patronymic = ''),
                (this.birth = ''),
                (this.snils = ''),
                (this.phone = ''),
                (this.email = ''),
                (this.currentSchool = '')
            this.confirmGrade = ''
        },
    },
    created() {
        this.$axios.get('/api/profiles').then((a) => {
            this.grades = a.data.profileList
        })
        const $script = document.createElement('script')
        $script.async = true
        $script.src =
            'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
        document.head.appendChild($script)
    },
    watch: {
        enterGrade: function () {
            this.getProfiles()
        },
    },
    computed: {
        gradesToShow() {
            return this.grades.filter(function (grade) {
                return !grade.disabled
            })
        },
        profileErrors() {
            const errors = []
            if (!this.$v.profile.$dirty) return errors
            !this.$v.profile.required && errors.push('Обязательное поле')
            return errors
        },
        surnameErrors() {
            const errors = []
            if (!this.$v.surname.$dirty) return errors
            !this.$v.surname.minLength && errors.push('Минимум 2 символа')
            !this.$v.surname.required && errors.push('Обязательное поле')
            return errors
        },
        nameErrors() {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.minLength && errors.push('Минимум 2 символа')
            !this.$v.name.required && errors.push('Обязательное поле')
            return errors
        },
        patronymicErrors() {
            const errors = []
            if (!this.$v.patronymic.$dirty) return errors
            !this.$v.patronymic.minLength && errors.push('Минимум 2 символа')
            !this.$v.patronymic.required && errors.push('Обязательное поле')
            return errors
        },
        enterGradeErrors() {
            const errors = []
            if (!this.$v.enterGrade.$dirty) return errors
            !this.$v.enterGrade.required && errors.push('Обязательное поле')
            return errors
        },

        snilsErrors() {
            const errors = []
            if (!this.$v.snils.$dirty) return errors
            !this.$v.snils.required && errors.push('Обязательное поле')
            !this.$v.snils.snilsVal && errors.push('Введите действущий СНИЛС')
            return errors
        },
        birthErrors() {
            const errors = []
            if (!this.$v.birth.$dirty) return errors
            !this.$v.birth.required && errors.push('Обязательное поле')
            !this.$v.birth.birthVal &&
                errors.push('Введите дату рождения в формате дд.мм.гггг')
            return errors
        },
        parentErrors() {
            const errors = []
            if (!this.$v.parent.$dirty) return errors
            !this.$v.parent.required && errors.push('Обязательное поле')
            return errors
        },
        phoneErrors() {
            const errors = []
            if (!this.$v.phone.$dirty) return errors
            !this.$v.phone.required && errors.push('Обязательное поле')
            !this.$v.phone.phoneVal &&
                errors.push('Введите номер телефона в формате х-ххх-ххх-хх-хх')
            return errors
        },
        emailErrors() {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Неверный формат почты')
            !this.$v.email.required && errors.push('Обязательное поле')
            return errors
        },
        checkboxErrors() {
            const errors = []
            if (!this.$v.terms.$dirty) return errors
            !this.$v.terms.sameAs && errors.push('Обязательное поле')
            return errors
        },
        currentSchoolErrors() {
            const errors = []
            if (!this.$v.currentSchool.$dirty) return errors
            !this.$v.currentSchool.required && errors.push('Обязательное поле')
            return errors
        },
        confirmGradeErrors() {
            const errors = []
            if (!this.$v.confirmGrade.$dirty) return errors
            !this.$v.confirmGrade.required && errors.push('Обязательное поле')
            return errors
        },
        rulesErrors() {
            const errors = []
            if (!this.$v.rules.$dirty) return errors
            !this.$v.rules.required && errors.push('Обязательное поле')
            return errors
        },
    },
    validations: {
        surname: { required, minLength: minLength(2) },
        name: { required, minLength: minLength(2) },
        patronymic: { required, minLength: minLength(2) },
        enterGrade: { required },
        profile: { required },
        currentSchool: { required },
        confirmGrade: { required },
        snils: {
            required,
            snilsVal: (val) => /^\d{3}-\d{3}-\d{3} \d{2}$/i.test(val),
        },
        birth: {
            required,
            birthVal: (val) =>
                /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/i.test(
                    val
                ),
        },
        parent: {
            required,
        },
        phone: {
            required,
            phoneVal: (val) =>
                /^(8-?|\+?7-?)?(\(?\d{3}\)?)-?(\d-?){6}\d$/i.test(val),
        },
        email: { required, email },
        terms1: {
            sameAs: sameAs(() => true),
        },
        terms2: {
            sameAs: sameAs(() => true),
        },
        // terms3: {
        //     sameAs: sameAs(() => true),
        // },
        terms4: {
            sameAs: sameAs(() => true),
        },
    },
}
</script>

<style>
.mycard {
    background-color: white;
    padding: 15px;
}
.v-btn {
    letter-spacing: 0.02em;
    text-transform: none;
}
.v-label {
    font-size: 12px;
}
.card-text {
    padding-bottom: 0 !important;
}
@media (max-width: 768px) {
    .nopadding {
        padding: 0;
        padding-left: 12px;
        padding-right: 12px;
    }
}
</style>
